/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { ComplexCtaCardsSectionFragment } from "@cosmos/hygraph-schema";

import { ResponsiveContainer, SectionContainer, SectionHeading, BackgroundContainer } from "@components/elements";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

import { ComplexCtaCards } from "./ComplexCtaCards.organism";

export const ComplexCtaCardsSection = ({
	config,
	cards,
	bottomDescription,
}: ComplexCtaCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length || bottomDescription);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack
						alignItems="stretch"
						gap="eds.dimension.48"
						className={cx(
							"complex-cta-cards-section",
							css({
								mdDown: {
									gap: "eds.dimension.40",
								},
							}),
						)}
					>
						{validHeading ? <SectionHeading {...config?.heading} titleDescStack={{ gap: "eds.dimension.16" }} /> : null}
						{validContent ? <ComplexCtaCards cards={cards || []} bottomDescription={bottomDescription} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
